import {AbstractControl, FormArray, FormGroup} from '@angular/forms';

export function isAnyFormFillStarted(formGroup: FormGroup): boolean {
    return Object.keys(formGroup.controls)
        .some((key) => {
            const control = formGroup.get(key);
            if (control instanceof FormGroup) {
                return isAnyFormFillStarted(control);
            }
            if (control instanceof FormArray) {
                return control.controls.some(item => isAnyFormFillStarted(item as FormGroup));
            }
            return control?.value !== null && control?.value !== undefined && control?.value !== '';
        });
}

export function collectDisabledControls(control: AbstractControl): AbstractControl[] {
    if (control instanceof FormGroup || control instanceof FormArray) {
        return Object.values(control.controls).flatMap(child => collectDisabledControls(child));
    }
    return control.disabled ? [control] : [];
}

export function restoreEnabledState(form: AbstractControl, disabledControls: AbstractControl[]): void {
    form.enable({emitEvent: false});
    disabledControls.forEach(control => control.disable({emitEvent: false}));
}

export function getNotValidFormFields(form: FormGroup): Record<string, any> {
    return Object.keys(form.controls).reduce((acc, k) => {
        const control = form.get(k);
        const status = form.get(k).status;
        if (Object.keys((control as FormGroup)?.controls ?? []).length && status === 'INVALID') {
            acc[k] = getNotValidFormFields(control as FormGroup);
        } else if (status === 'INVALID') {
            acc[k] = {
                status: form.get(k).status,
            };
        }
        return acc;
    }, {} as Record<string, any>);
}
